export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_ERROR = "SEND_NOTIFICATION_ERROR";
export const SEND_NOTIFICATION_V2 = "SEND_NOTIFICATION_V2";
export const SEND_NOTIFICATION_V2_SUCCESS = "SEND_NOTIFICATION_V2_SUCCESS";
export const SEND_NOTIFICATION_V2_ERROR = "SEND_NOTIFICATION_V2_ERROR";
export const TOGGLE_NOTIFICATION_MODAL = "TOGGLE_NOTIFICATION_MODAL";
